import { Paper, Typography } from '@material-ui/core';
import styled, { css } from 'styled-components';

import { getIcon } from 'app/components/ErplyIcon';

export const StyledPrice = styled(Typography)<{ $afterContent: string }>`
  position: relative;
  padding-left: 0.8rem;
  line-height: 3.5rem;
  font-weight: 300;
  font-style: normal;
  font-size: 3rem;

  ::before {
    position: absolute;
    content: '$';
    font-size: 1.25rem;
    line-height: 1.5rem;
    top: 0.63rem;
    left: 0;
  }
  ::after {
    content: '${({ $afterContent }) => $afterContent}';
    font-size: 1rem;
  }
`;
export const StyledPaper = styled(Paper)<{
  $selected?: boolean;
  $error?: boolean;
  $confirmView?: boolean;
  $isOpen: boolean;
}>`
  width: 100%;
  max-width: 21.25rem;

  display: flex;
  flex-flow: column;

  padding: 1rem;
  margin: 0 auto 0.63rem auto;
  border: 1.5px solid
    ${({
      $error,
      theme: {
        palette: { error, primary },
      },
    }) => ($error ? error.main : primary.main)};
  transition: background-color ease 0.2s;
  background-color: ${({
    theme: {
      palette: {
        primary: { light },
      },
    },
  }) => light};

  cursor: pointer;

  .title {
    margin-bottom: 5px;
    display: flex;

    .expand {
      display: flex;
      margin-left: auto;

      transform-origin: center;
      transform: rotate(${({ $isOpen }) => ($isOpen ? 90 : 0)}deg);
      transition: transform ease 0.5s;

      ::before {
        margin: auto 0;
        font-family: Erply-Icons, serif;
        content: '${getIcon('Chevron-Left')}';
        font-size: 20px;
      }
    }
  }
  .description {
    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.1);
    margin-bottom: 1rem;
  }
  .price {
    display: flex;
    justify-content: space-between;
    align-items: center;
    ${StyledPrice} {
      margin-block-end: -0.8rem;
    }
    ${({ $confirmView }) =>
      $confirmView &&
      css`
        flex-flow: column;
        align-items: flex-start;
      `}
    .btn-select {
      ${({
        $selected,
        theme: {
          palette: {
            primary: { main },
          },
        },
      }) =>
        $selected
          ? css`
              background-color: white;
              color: ${main};
            `
          : ''};
      padding: 0.63rem 1rem;
    }
  }
  ${({
    $selected,
    theme: {
      palette: {
        primary: { main },
      },
    },
  }) =>
    $selected &&
    css`
      background-color: ${main};
      color: white;
      .price {
        .btn-select {
          background-color: white;
          color: ${main};
        }
      }
    `}
`;
export const List = styled.ul<{
  $isOpen: boolean;
  $height: number;
  $selected?: boolean;
}>`
  padding-inline-start: 0;
  transition: height ease 0.5s;
  height: ${({ $isOpen, $height }) => ($isOpen ? `${$height}px` : 0)};
  margin: 0.5rem auto 0 auto;

  overflow-y: hidden;
  list-style: none;
  li {
    display: flex;
    ::before {
      font-family: Erply-Icons, serif;
      content: '${getIcon('Checkmark')}';
      color: ${({
        theme: {
          palette: {
            primary: { main },
          },
        },
      }) => main};
      font-size: 1.3rem;
    }
  }
  ${({ $selected }) =>
    $selected &&
    css`
      color: white;
      li {
        ::before {
          color: white;
        }
      }
    `};
`;
